import { inject } from "@angular/core";
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { User } from "@services/user.service";
import { Router as RouterService } from "@services/route.service";


export const hasRightGuard: CanActivateFn=(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const userS=inject(User);
  const routerS=inject(RouterService);
  const router=inject(Router);

  const right: string=_route.data?.['right'] ?? null;

  // returns `true` if the user is logged in or redirects to the login page
  // note that you can also use `router.createUrlTree()` to build a `UrlTree` with parameters
  return userS.hasRight(right) || router.parseUrl(routerS.get('login'));
};
